/**
 * @type {QueryBuilder}
 */
const QueryBuilder = {
  and: (...params) => ['AND', ...params],
  or: (...params) => ['OR', ...params],
};

export default QueryBuilder;
